<template>
  <div id="login">
    <van-form @submit="login">
      <h2>欢迎登录一起答</h2>
      <van-field
        v-model="LoginForm.mobile"
        label="用户名"
        placeholder="请输入手机号/用户名"
        clearable
        :rules="[{ required: true, message: '请输入手机号/用户名' }]"
      />
      <van-field
        v-model="LoginForm.password"
        type="password"
        label="密码"
        placeholder="请输入密码"
        clearable
        :rules="[{ required: true, message: '请输入密码' }]"
      />
      <van-field
        v-model="LoginForm.captcha"
        label="验证码"
        placeholder="请输入右侧验证码"
        clearable
        :rules="[{ required: true, message: '请输入右侧显示的验证码' }]"
         v-if="needCaptcha"
      >
        <template #button>
          <img :src="captchaUrl" @click="changeCaptcha" height="28" width="100" style="margin-left: 10px; display: block;" />
        </template>
      </van-field>
      <div style="padding: 16px;">
        <van-button round block type="primary" native-type="submit">
          立即登录
        </van-button>
      </div>
    </van-form>
    <div style="text-align: center;">
      <router-link :to="{name: 'FindpwdSelectMethod'}" style="color: #323233;"> 忘记密码 </router-link>
      |
      <router-link :to="{name: 'Register'}" style="color: #323233;"> 立即注册 </router-link>
    </div>
  </div>
</template>

<script>
  import { getUrlParams } from '../utils/common'
  import { mapGetters } from 'vuex'
  export default {
    name: 'Login',
    data () {
      return {
        LoginForm: {
          mobile: '',
          password: '',
          captcha: '',
          remember: 1
        },
        isDisable: false,
        captchaUrl: this.$api.global.getCaptchaUrl(),
        needCaptcha: false
      }
    },
    computed: {
      ...mapGetters({
        loginState: 'user/loginState'
      })
    },
    created () {
      if (this.loginState) {
        this.$router.push({ name: 'UserCenter' })
      } else {
        this.detectneedCaptcha()
      }
    },
    methods: {
      changeCaptcha () {
        this.captchaUrl = this.$api.global.getCaptchaUrl()
      },
      login (formName) {
        this.isDisable = true
        this.$store.dispatch('user/Login', this.LoginForm)
          .then(res => {
            if (res.data.code === 200) {
              const redirect = getUrlParams('redirect')
              if (redirect) {
                top.window.location = decodeURIComponent(redirect)
              } else {
                this.$router.push({ name: 'UserCenter' })
              }
            } else {
              this.$notify(res.data.message)
              this.isDisable = false
              this.changeCaptcha()
              this.detectneedCaptcha()
            }
          })
          .catch(() => {
            this.isDisable = false
          })
      },
      detectneedCaptcha () {
        this.$api.global.needCaptcha()
          .then((res) => {
            if (res.data.code === 200) {
              this.needCaptcha = res.data.data.iscaptcha
            } else {
              this.needCaptcha = true
            }
          })
          .catch(() => {
            this.needCaptcha = true
          })
      },
      goRegister () {
        this.$router.push({ name: 'Register' })
      },
      loginWithQq () {
        top.window.location = this.$api.user.getQQLoginUrl()
      },
      loginWithWeixin () {
        top.window.location = this.$api.user.getWeixinLoginUrl()
      },
      loginWithWeibo () {
        top.window.location = this.$api.user.getWeiboLoginUrl()
      }
    }
  };
</script>